import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { SliderResponse } from "../interfaces/slider-info.interface";
import { Observable } from "rxjs";
import { environment } from "../../../../../environments/environment";

@Injectable
  ({
    providedIn: 'root'
  })
export class SliderService {

  private readonly apiUrl = environment.api_baseUrl;
  http = inject(HttpClient);



  getSlides(): Observable<SliderResponse> {
    return this.http.get<SliderResponse>(`${this.apiUrl}/api/banners/get`);
  }

}
